import redWhiteBlocks from './redWhiteBlocks';
import { isLocalUrl } from '../../helpers/helpers';

async function showData() {
  const whiteData = (await redWhiteBlocks('whiteBlocks', whiteBlocksOpts, 'white')) || [];
  const redData = (await redWhiteBlocks('redBlocks', redBlocksOpts, 'red')) || [];

  const maxLength = Math.max(whiteData.length, redData.length);
  const mergedData = [];

  for (let i = 0; i < maxLength; i++) {
    if (whiteData[i]) mergedData.push(whiteData[i]);
    if (redData[i]) mergedData.push(redData[i]);
  }

  return mergedData;
}

function blocksStructure(colorBlock = '', data = {}) {
  const itemId = data.id || 0;
  const title = data.Title || '';
  const description = data.Description || '';
  const url = data.URL || '';
  const urlAttribute = url && !isLocalUrl(url) ? 'target="_blank"' : '';
  const imageUrl = data.Image || '';

  const imageAttributes =
    colorBlock === 'white' && imageUrl
      ? `style="background-image: url('${imageUrl}');" data-background-image="${imageUrl}"`
      : '';

  return `
    <div class="${colorBlock}" id="block-${colorBlock}-${itemId}">
      <div class="inner-container">
        <div class="block-image" ${imageAttributes}></div>
        <div class="block-outer-content">
          <div class="block-inner-content">
            <h3 class="block-title">${title}</h3>
            ${description ? `<span class="block-paragraph">${description}</span>` : ''}
            ${url ? `<a href="${url}" class="button" ${urlAttribute}>Learn More</a>` : ''}
          </div>
        </div>
      </div>
    </div>
  `;
}

export default async function runStructure() {
  const data = await showData();

  for (const item of data) {
    $('#blocksStructure').append(blocksStructure(item.color, item));
  }
}
